import React, { useContext, useEffect } from 'react';
import { NextPageContext } from 'next';
import { appAuthContext } from 'context/AuthContext';
import clickStreamPageview from 'utils/clickstream/useClickStreamPageview';
import Main from 'views/Main';
import { QuestionApiResponse } from 'types/Questions.types';
import { getLayout } from 'components/Layout/Layout';
import getAdvegoQuestions from 'views/Main/api/getAdvegoQuestions';
import getQuerySSR from 'utils/getQuerySSR';
import getCountByCategories from 'views/Main/api/getCountByCategories';
import { CountByCategoriesResponse } from 'views/Main/types/getCountByCategories';
import styles from './index.module.css';

type HomePageProps = {
  data: QuestionApiResponse | null;
  page: number;
  countByCategories: CountByCategoriesResponse | null;
};

const Home = ({ data, page, countByCategories }: HomePageProps) => {
  const { user } = useContext(appAuthContext);

  useEffect(() => {
    clickStreamPageview({
      id: user?.data?.attributes?.foreign_id,
      userType: user?.data?.attributes?.type,
    });
  }, []);

  return (
    <div className={styles.wrapper}>
      <Main data={data} page={page} countByCategories={countByCategories} />
    </div>
  );
};

Home.getLayout = getLayout;

export async function getServerSideProps(params: NextPageContext) {
  const page = getQuerySSR(params.query?.page);
  const [countByCategories, data] = await Promise.all([
    getCountByCategories(params),
    getAdvegoQuestions(page, params),
  ]);

  if (!countByCategories || !data) {
    return {
      redirect: {
        permanent: false,
        destination: '/500',
      },
      props: {},
    };
  }

  const title = `Вопросы и ответы онлайн | Учи.Ответы${
    page && +page > 1 ? `, cтраница ${page}` : ''
  }`;
  const description = `Задай вопрос онлайн и получи ответ на Учи.Ответы${
    page && +page > 1 ? `, cтраница ${page}` : ''
  }`;

  return {
    props: {
      data,
      page: page || 1,
      countByCategories,
      title,
      description,
    },
  };
}

export default Home;
